<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>大转盘配置</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="金币体力大转盘" name="second">

            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=>{return importProbUploadSuccess(res, 'second')}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:trun:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:trun:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData('second')"
                >导出</el-button>
              </el-col>
            </el-row>

            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formPlusData" :key="index">
                <el-form-item label="关卡">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="关卡" />
                </el-form-item>
                <el-form-item v-for="(pro, i) in item.chess_board_pro" :key="i" :label="'概率配置'+i">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="turntPlusConfigVisibleArr[index][i].visible = true" />
                  <el-dialog title="概率配置" :before-close="(v)=>{return handlePlusClose(v, index, i)}" width="790px" :visible="turntPlusConfigVisibleArr[index][i].visible">
                    <el-form>
                      <el-row>
                        <el-form-item style="margin-top: 10px;" label="ID">
                          <el-input v-model.number="pro.id" :prop="'formPlusData.' +index +'.chess_board_pro.'+i+'.id'" style="width: 80px" placeholder="关卡" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="概率">
                          <el-input v-model.number="pro.v" :prop="'formPlusData.' +index +'.chess_board_pro.'+i+'.v'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="类型">
                          <el-input v-model.number="pro.type" :prop="'formPlusData.' +index +'.chess_board_pro.'+i+'.type'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="数量">
                          <el-input v-model.number="pro.num" :prop="'formPlusData.' +index +'.chess_board_pro.'+i+'.num'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                      </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="turntPlusConfigVisibleArr[index][i].visible = false">取 消</el-button>
                      <el-button type="primary" @click="turntPlusConfigVisibleArr[index][i].visible = false">确 定</el-button>
                    </div>
                  </el-dialog>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:turn:add']" type="primary" @click="add('second')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:turn:add']" type="primary" @click="onSubmit('second')">保存</el-button>
            </el-form>

            <pagination
              v-show="turnPlusPage.total>0"
              background
              :page.sync="turnPlusPage.queryParams.pageIndex"
              :limit.sync="turnPlusPage.queryParams.pageSize"
              :total="turnPlusPage.total"
              @pagination="getTables('second')"
            />
          </el-tab-pane>
          <el-tab-pane label="大转盘配置修改" name="first">
            <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
              <el-col :span="1.5">
                <el-upload
                  class="upload-demo"
                  :action="sys_app_logoAction"
                  accept="xlsx"
                  :limit="1"
                  :on-success="(res)=>{return importProbUploadSuccess(res, 'first')}"
                  :headers="headers"
                >
                  <el-button v-permisaction="['config:turn:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>

              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:turn:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData('first')"
                >导出</el-button>
              </el-col>
            </el-row>
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData" :key="index">
                <el-form-item label="关卡">
                  <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="关卡" />
                </el-form-item>
                <el-form-item v-for="(pro, i) in item.chess_board_pro" :key="i" :label="'概率配置'+i">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="turntConfigVisibleArr[index][i].visible = true" />
                  <el-dialog title="概率配置" :before-close="(v)=>{return handleClose(v, index, i)}" width="790px" :visible="turntConfigVisibleArr[index][i].visible">
                    <el-form>
                      <el-row>
                        <el-form-item style="margin-top: 10px;" label="ID">
                          <el-input v-model.number="pro.id" :prop="'formData.' +index +'.chess_board_pro.'+i+'.id'" style="width: 80px" placeholder="关卡" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="概率">
                          <el-input v-model.number="pro.v" :prop="'formData.' +index +'.chess_board_pro.'+i+'.v'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="支付概率">
                          <el-input v-model.number="pro.pv" :prop="'formData.' +index +'.chess_board_pro.'+i+'.pv'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="广告概率">
                          <el-input v-model.number="pro.av" :prop="'formData.' +index +'.chess_board_pro.'+i+'.av'" style="width: 80px" placeholder="概率" autocomplete="off" />
                        </el-form-item>
                        <el-form-item style="margin-top: 10px;" label="金币">
                          <el-input v-model.number="pro.prize" :prop="'formData.' +index +'.chess_board_pro.'+i+'.iprized'" style="width: 80px" placeholder="金币" autocomplete="off" />
                        </el-form-item>
                      </el-row>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="turntConfigVisibleArr[index][i].visible = false">取 消</el-button>
                      <el-button type="primary" @click="turntConfigVisibleArr[index][i].visible = false">确 定</el-button>
                    </div>
                  </el-dialog>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:turn:add']" type="primary" @click="add('first')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:turn:add']" type="primary" @click="onSubmit('first')">保存</el-button>
            </el-form>
            <pagination
              v-show="turnPage.total>0"
              background
              :page.sync="turnPage.queryParams.pageIndex"
              :limit.sync="turnPage.queryParams.pageSize"
              :total="turnPage.total"
              @pagination="getTables('second')"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import { getTurnCfgList, getTurnPlusCfgList, updateTurnCfg, exportTurnCfg, importTurnCfg } from '@/api/config/turn-cfg'
export default {
  name: 'TurntConfig',
  data() {
    return {
      turnPage: {
        total: 0,
        queryParams: {
          pageIndex: 1,
          pageSize: 10
        }
      },
      turnPlusPage: {
        total: 0,
        queryParams: {
          pageIndex: 1,
          pageSize: 10
        }
      },
      activeName: 'second',
      turntConfigVisibleArr: [
        [{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }]
      ],
      turntPlusConfigVisibleArr: [
        [{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }]
      ],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      formData: [{
        'levelId': 0,
        'chess_board_pro': [{
          'id': 1,
          'v': 2,
          'av': 3,
          'pv': 4,
          'prize': 5
        }, {
          'id': 2,
          'v': 3,
          'av': 4,
          'pv': 5,
          'prize': 0
        }, {
          'id': 3,
          'v': 0,
          'av': 0,
          'pv': 0,
          'prize': 0
        }, {
          'id': 4,
          'v': 0,
          'av': 0,
          'pv': 0,
          'prize': 0
        }, {
          'id': 5,
          'v': 0,
          'av': 0,
          'pv': 0,
          'prize': 0
        }]
      }],
      formPlusData: [{
        'levelId': 0,
        'chess_board_pro': [{
          'id': 1,
          'v': 2,
          'type': 2,
          'num': 2
        }, {
          'id': 1,
          'v': 2,
          'type': 2,
          'num': 2
        }, {
          'id': 1,
          'v': 2,
          'type': 2,
          'num': 2
        }, {
          'id': 1,
          'v': 2,
          'type': 2,
          'num': 2
        }]
      }]
    }
  },
  created() {
    this.getTables('second')
  },
  methods: {
    onSubmit(name) {
      let data = []
      if (name === 'first') {
        data = JSON.stringify(this.formData)
      } else {
        data = JSON.stringify(this.formPlusData)
      }
      console.log(data)
      updateTurnCfg({ data: data, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done, index, i) {
      this.turntConfigVisibleArr[index][i].visible = false
    },
    handlePlusClose(done, index, i) {
      this.turntPlusConfigVisibleArr[index][i].visible = false
    },
    getTables(name) {
      console.log(name)
      if (name === 'first') {
        getTurnCfgList(this.turnPage.queryParams).then(res => {
          this.turntConfigVisibleArr = []
          this.formData = []
          res.data.list.forEach((item, index) => {
            item.chess_board_pro.forEach(() => {
              this.turntConfigVisibleArr.push([{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }])
            })
            this.turnPage.total = res.data.count
          })
          this.formData = res.data.list
        })
      } else {
        this.formPlusData = this.turntPlusConfigVisibleArr = []
        getTurnPlusCfgList(this.turnPlusPage.queryParams).then(res => {
          res.data.list.forEach((item, index) => {
            this.turntPlusConfigVisibleArr.push([{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }])
          })
          this.formPlusData = res.data.list
          this.turnPlusPage.total = res.data.count
        })
      }
    },
    add(name) {
      if (name === 'first') {
        this.formData.push({
          'levelId': 0,
          'slotpro': [{
            'id': 1,
            'v': 0,
            'av': 0,
            'pv': 0,
            'prize': 0
          }, {
            'id': 1,
            'v': 0,
            'av': 0,
            'pv': 0,
            'prize': 0
          }, {
            'id': 3,
            'v': 0,
            'av': 0,
            'pv': 0,
            'prize': 0
          }, {
            'id': 4,
            'v': 0,
            'av': 0,
            'pv': 0,
            'prize': 0
          }, {
            'id': 5,
            'v': 0,
            'av': 0,
            'pv': 0,
            'prize': 0
          }]
        })
        this.turntConfigVisibleArr.push([{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }])
      } else {
        this.formPlusData.push({
          'levelId': 0,
          'slotpro': [{
            'id': 1,
            'v': 2,
            'type': 2,
            'num': 2
          }, {
            'id': 1,
            'v': 2,
            'type': 2,
            'num': 2
          }, {
            'id': 1,
            'v': 2,
            'type': 2,
            'num': 2
          }, {
            'id': 1,
            'v': 2,
            'type': 2,
            'num': 2
          }]
        })
        this.turntPlusConfigVisibleArr.push([{ 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }, { 'visible': false }])
      }
      console.log(this.turntPlusConfigVisibleArr)
    },
    exportData(name) {
      console.log(name)
      exportTurnCfg({ name: name }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response, name) {
      console.log('导入', name)
      importTurnCfg({ data: response.data.path, name: name }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importMoneyUploadSuccess(response, file, fileList) {
      // importSlotWeightCfg({ path: response.data.path, ImportType: 2 }).then(res => {
      //   // eslint-disable-next-line eqeqeq
      //   if (res.code === 200) {
      //     this.msgSuccess(res.msg)
      //     this.getTables()
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.getTables(tab.name)
    },
    errorCaptured(err, vm, info) {
      console.log(`捕获到Vue实例的错误：${err}, 跟踪信息: ${info}`)
    }
  }
}
</script>

<style scoped>
</style>
